import React from 'react';
import { COLORS } from 'Components/utils/color/colors';
import { Text } from 'Components/frameworks/text/Text';
export type ProductFeatureDetailServiceItemProps = {
  className?: string;
  description?: string;
  items?: Array<ProductFeatureDetailServiceItemProps>;
  label?: string;
  note?: string;
  tag?: {
    color?: Colors;
    label?: string;
  };
};
export function ProductFeatureDetailServiceItem(props: ProductFeatureDetailServiceItemProps) {
  const { className, description, items = [], label, note, tag } = props;
  return (
    <li className={className}>
      {!!label && <div className="font-bold">{label}</div>}
      {!!description && <Text className="mb-5 inline-block" text={description} />}
      {!!tag?.label && (
        <span className={`font-bold text-${tag.color || COLORS.BLACK} mb-5`}>
          {` ${tag.label}`}
        </span>
      )}
      {!!note && <small className="block">{note}</small>}
      {!!items.length && (
        <ul className="list-none p-0 text-14 leading-normal text-black">
          {items.map((item, _i) => (
            <ProductFeatureDetailServiceItem
              className="list-disc"
              description={item.description}
              items={item.items}
              key={item.description}
              label={item.label}
              note={item.note}
              tag={item.tag}
            />
          ))}
        </ul>
      )}
    </li>
  );
}
